// src/utils/positions.ts

// Why: hoist constants to avoid realloc per call.
const POSITION_MAP: Record<string, readonly string[]> = {
  "top-left": ["top-0","left-0"],
  "top-center": ["top-0","left-1/2","-translate-x-1/2"],
  "top-right": ["top-0","right-0"],
  "middle-left": ["top-1/2","left-0","-translate-y-1/2"],
  "center": ["top-1/2","left-1/2","-translate-x-1/2","-translate-y-1/2"],
  "middle-right": ["top-1/2","right-0","-translate-y-1/2"],
  "bottom-left": ["bottom-0","left-0"],
  "bottom-center": ["bottom-0","left-1/2","-translate-x-1/2"],
  "bottom-right": ["bottom-0","right-0"],
} as const;

function normToken(token?: string): string {
  const t = String(token || "bottom-right").trim().toLowerCase().replace(/\s+|_/g, "-");
  // Why: accept common synonyms from content/front-matter.
  if (t === "middle" || t === "centre") return "center";
  if (t === "middle-center") return "center";
  if (t === "middle-left" || t === "center-left") return "middle-left";
  if (t === "middle-right" || t === "center-right") return "middle-right";
  return t;
}

/** Horizontal text alignment via Tailwind classes. */
export function getAlignClass(align: string): string {
  const a = (align || "").toLowerCase();
  if (a === "left") return "text-left";
  if (a === "right") return "text-right";
  return "text-center";
}

/** Vertical alignment for flexbox sections (Tailwind). */
export function getVerticalAlignClass(position: string): string {
  const p = (position || "").toLowerCase();
  if (p === "top") return "items-start";
  if (p === "bottom") return "items-end";
  return "items-center";
}

export function getPositionClasses(token?: string): string[] {
  const t = normToken(token);
  const mapped = POSITION_MAP[t] ?? POSITION_MAP["bottom-right"];
  // return a fresh array; never mutate the map's arrays.
  return ["absolute", "p-3", ...mapped];
}

export function applyZIndexAndPointer(
  el: HTMLElement,
  z?: number | string,
  pointer: "auto" | "none" = "none"
): void {
  if (!el) return;
  if (z != null && String(z).trim() !== "") {
    el.style.zIndex = String(z).trim();
  }
  el.style.pointerEvents = pointer === "auto" ? "auto" : "none";
}